import { BackgroundCheckStatus, backgroundCheckStatuses } from '@/backend/features/background-check/types';
import { getBackgroundCheckIcon, isValidBackgroundCheckStatus } from '@/ui/utils/backgroundCheckStatusUtils';
import { TransparentBox } from '@juvare/common-web-ui/TransparentBox';
import { ProfileScreeningCard } from '@juvare/credentialing/ui/features/credentialing-verification';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ProfileBackgroundCheckCardProps {
    backgroundCheckStatus?: BackgroundCheckStatus;
    cardTitle?: string;
}

export const ProfileBackgroundCheckCard: React.FC<ProfileBackgroundCheckCardProps> = ({ backgroundCheckStatus, cardTitle }) => {
    const { t } = useTranslation();
    const { Icon, color } = getBackgroundCheckIcon(backgroundCheckStatus);
    const status = backgroundCheckStatuses[backgroundCheckStatus ?? 'unknown'] ?? t('common.statusNotDefined');
    const isError = backgroundCheckStatus ? !isValidBackgroundCheckStatus(backgroundCheckStatus) : false;

    return (
        <TransparentBox data-test='background-check-box'>
            <ProfileScreeningCard
                cardTitle={cardTitle ?? t('credentialing.backgroundCheck')}
                icon={<Icon />}
                iconColor={color}
                status={status}
                isError={isError}
            />
        </TransparentBox>
    );
};
